import React from 'react';

const IconArrow = () => {
  return (
    <svg
      width='28'
      height='28'
      viewBox='0 0 28 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.0215 8.645L15.3648 14L10.0215 19.355L11.6665 21L18.6665 14L11.6665 7L10.0215 8.645Z'
        fill='#B9B5B4'
      />
    </svg>
  );
};

export default IconArrow;
